import { LineUp } from '../components/lineup.vue';
Vue.component('lineup', LineUp);